import * as Form from './styles'
import FileUploadField from './FileUpload'
import DatePickerField from './DatePicker'

export default { ...Form, FileUploadField, DatePickerField }
